/*eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import emailValid from '../../helpers/emailValid'
import { fetchLead } from '../../api'

export default class Connect extends Component {
	state = {
		airtableId: null,
		firstName: null,
		loading: true,
		email: null,
		mixpanelId: null,
		error: null
	}

	fetchLead = async () => {
		const lead = await fetchLead(this.props.match.params.airtableId)
		// Fetch the profile & identify the user to mixpanel
		if(lead) {
			let mixpanelId = null
			if(window.mixpanel) {
				const distinctId = window.mixpanel.get_distinct_id()
				mixpanelId = emailValid(distinctId) ? distinctId : lead.email
				window.mixpanel.identify(mixpanelId)
			}
			this.setState({
				mixpanelId,
				email: lead.email,
				airtableId: this.props.match.params.airtableId,
				firstName: lead.first_name,
				loading: false
			})
		} else {
			this.setState({
				loading: false,
				error: 'Could not fetch the report.'
			})
		}
	}

	loadTypeform = () => {
		var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id='typef_orm', b='https://embed.typeform.com/'
		if(!gi.call(d,id)) {
			js=ce.call(d,'script')
			js.id=id; js.src=b+'embed.js'
			q=gt.call(d,'script')[0]
			q.parentNode.insertBefore(js,q)
		}
	}

	componentDidMount() {
		
		this.fetchLead().then(() =>{
			// Add mixpanel event here
			// If the user hasn't already submitted the form, load typeform
			this.loadTypeform()
		})
	}

	render() {
		let { airtableId, firstName, loading, mixpanelId, error } = this.state

		if(loading) {
			return (
				<p>Loading your survey...</p>
			)
		} else {
			if(error) {
				return (
					<p>{error}</p>
				)
			} else {
				if(window.mixpanel) {
					window.mixpanel.track('[Creative Connector] - Loaded form', {
						airtableId
					})
				}
				return (
					<Fragment>
						<div
							className="typeform-widget"
							data-url={`https://unifiedinc.typeform.com/to/mGXh8S?fn=${firstName}&code=${airtableId}&uid=${mixpanelId}`}
							style={{width: '100%', height: '100vh'}}
						></div>
					</Fragment>
				)
			}
		}
	}
}

Connect.propTypes = {
	match: PropTypes.object // Used to get the Lead ID
}


// WEBPACK FOOTER //
// ./src/containers/Connect/index.js